<!-- 车主信息下发接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "ownerId":"001",
                "name":"allen",
                "telphone":"13823222222",
                "operateTime":"2017-07-04 13:14:15",
                "operator":"operaotr","sex":"2"},
            responseCode: 	{
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台下发某个车主信息",
                t_url: this.commonUrls.test+"addVipCustomer",
                p_url: this.commonUrls.prod+"addVipCustomer",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'ownerId', info2: '是', info3: 'String', info4: '车主ID，外部平台分配的车主ID，用于唯一识别一个车主' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '车主姓名' },
                        { info1: 'sex', info2: '否', info3: 'String', info4: '车主性别，0男 1女 2未知' },
                        { info1: 'idCard', info2: '否', info3: 'String', info4: '身份证号' },
                        { info1: 'telphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'company', info2: '否', info3: 'String', info4: '车主公司' },
                        { info1: 'department', info2: '否', info3: 'String', info4: '车主部门' },
                        { info1: 'address', info2: '否', info3: 'String', info4: '住址' },
                        { info1: 'roomNo', info2: '否', info3: 'String', info4: '房间号' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'remark1', info2: '否', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '否', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '否', info3: 'String', info4: '备注3' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/addVipCustomer.vue